import smoothScroll from '@plugins/smooth-scroll';

export default (el) => {
  const $metaContainer = $(el).find('.case-studies-block-meta'),
        $userSelections = $metaContainer.find('.case-studies-block-meta-selections')
  ;

  $(document)
    // This JS event gets triggered before FacetWP begins the refresh process.
    //
    // It happens before any AJAX is requested, and before the URL hash gets updated.
    // This event is useful for modifying any FWP variables before getting sent to the server.
    .on('facetwp-refresh', () => {
      window.packbackLoading.addEvent('facetwp-refresh', true);
    })
    // This JS event gets triggered when FacetWP finishes refreshing.
    //
    // It’s triggered after a user interacts with a facet or pagination control.
    // This event is useful for modifying facet output after being rendered.
    .on('facetwp-loaded', () => {
      // Clear the user selections container
      $userSelections.empty();

      // Smooth scroll to the top of the results
      // if (FWP.loaded) {
      //   smoothScroll($('.facetwp-scroll-target').offset().top - 32, false);
      // }

      // If there are no active facet selections, hide the container and end the loading event
      if ('' === FWP.buildQueryString()) {
        $userSelections.hide();
        window.packbackLoading.endEvent('facetwp-refresh');
        return;
      }

      // Get the selected facets
      let selectedFacets = FWP.facets;

      // If there is a pagination facet, remove it from the selected facets
      if (Object.hasOwn(selectedFacets, 'pagination')) {
        delete selectedFacets.pagination;
      }

      // Filter out any empty facets
      selectedFacets = Object.keys(selectedFacets)
        .filter((key) => selectedFacets[key].length)
        .reduce((acc, key) => {
          acc[key] = selectedFacets[key];
          return acc;
        }, {});

      // Iterate over facets with a selection
      for (const [facetName, facetValues] of Object.entries(selectedFacets)) {
        // Iterate over each selected value
        facetValues.forEach((facetSingleValue) => {
          // Get the display value for the selected value
          const displayValue = $(
            `.facetwp-facet-${facetName} [data-value="${facetSingleValue}"] .facetwp-display-value`
          ).text();

          // Add the selected value to the user selections container
          $userSelections.append(
            `<li>
              <button
                class="js-facet-user-selection"
                type="button"
                data-facet="${facetName}"
                data-value="${facetSingleValue}"
              >${displayValue}</button>
            </li>`
          );
        });
      }

      // Show the meta container
      $userSelections.show();

      // End the loading event
      window.packbackLoading.endEvent('facetwp-refresh');
    })
    // Remove facet selection on click
    .on('click', '.js-facet-user-selection', ({ currentTarget }) => {
      const $target = $(currentTarget),
            facetName = $target.data('facet'),
            facetValue = $target.data('value')
      ;

      // If the facet value is not empty, reset the facet value
      if ('' !== facetValue) {
        FWP.reset({ [facetName]: facetValue });

        // If the facet value is empty, reset the entire facet
      } else {
        FWP.reset(facetName);
      }
    })
    // Smooth scroll to top of results on pagination click
    .on('click', '.facetwp-pager a', (e) => {
      e.preventDefault();
      smoothScroll($('.facetwp-scroll-target').offset().top - 40, false);
    })
  ;
};
